import { CustomTabProps } from '../../interfaces';
import { TabWrapper } from './styles';

const TabWithAmount: React.FC<CustomTabProps> = props => {
  const { children, amount } = props;
  return (
    <TabWrapper>
      {children}
      <div className="quantity">{amount}</div>
    </TabWrapper>
  );
};

export default TabWithAmount;
